import $ from 'jquery';
import componentize from './componentize';
const slick = require('slick-carousel'); // eslint-disable-line no-unused-vars

export default function (id, dataModel, view) {
    return componentize({
        query: '#' + id + ' .slideshow',
        attachedCallback: function () {
            const $this = $(this);
            this.$el = $this;
            this.dataModel = dataModel;
            this.view = view;

            // these are default settings that all of our carousels tend to use
            let slickConfig = {
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow"></i></button>'
            };


            this.initializeCarousel(slickConfig);
            // after click but before slide has changed
            $this.on('beforeChange', (e, slickObj, currentSlide, nextSlide)=>this.beforeChange(e, slickObj, currentSlide, nextSlide));
            return this;
        },
        initializeCarousel: function (slickConfig) {
            const $this = this.$el;
            $this.slick(slickConfig);
            this.disableBackBtn();
        },
        addSlide: function (markup, nextSlide) {
            this.$el.slick('slickAdd', markup,  nextSlide);
        },

        beforeChange: function (event, slickObj, currentSlide, nextSlide) {
            // for some reason, on certain letters, datamodel finished is never being set
            // need to be debug this, but not that important
            const isThereMoreData = !this.dataModel.finished;
            if (currentSlide === 1 && nextSlide === 0 && isThereMoreData) {
                this.disableBackBtn();
            } else {
                // this.enableBackBtn();
            }

            if (event && currentSlide % 2 === 0 && currentSlide - nextSlide === -1) {
                if (!this.dataModel.finished && !this.dataModel.alreadyCalledSlideIndex.hasOwnProperty(nextSlide)) {
                    this.dataModel.get(nextSlide).then((data) => {
                        if (data) {
                            const markup = this.view.populateSlides(data, event);
                            this.addSlide(markup, nextSlide);
                        }

                    }).catch((error) => {
                        this.dataModel.setFinishedState();
                        console.error(error); // eslint-disable-line no-console
                    });

                }
            }

        },

        disableBackBtn: function () {
            this.$el.find('.slick-prev').hide();
        },
        enableBackBtn: function () {
            this.$el.find('.slick-prev').show();
        }

    });
}
